<div class="fullcontainer" >
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header' style='color: #006498'>All Driver Absence</h2>

    <div>
      <button class='btn btn-secondary' routerLink='/drivers/absence/new'><i class="fas fa-plus"></i> New</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/drivers'><i class="fas fa-arrow-left"></i> Back</button>
    </div>
  </div>
  <br />
  <br />
  <app-grid
entity='driver-absence'
[filters]='this.filters'
[columns]='this.columns'
[buttons]='this.buttons'
[searchFilters]='this.searchFilters'
[searchFields]='this.searchFields'
></app-grid>
